import { HOST } from '../config';
import axios from 'axios';

const connectivityInstance = axios.create({
  timeout: 10 * 1000,
  headers: {
    'x-log-apiversion': '0.6.0',
    'x-log-bodyrawsize': 1234,
  },
});

export function connectivity(urlList) {
  return new Promise((resolve) => {
    const result = [];
    urlList.forEach((item) => {
      connectivityInstance
        .post(item.url, item.param)
        .then(() => {
          result.push(true);
        })
        .catch(() => {
          result.push(false);
        })
        .finally(() => {
          if (result.length === urlList.length) {
            resolve(result);
          }
        });
    });
  });
}
